module.exports = __webpack_public_path__ + "static/media/lixeira-vermelha.406cd1e6.svg";